import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  loadObservationsForCycleRequest,
  loadObservationsForCycleSuccess,
} from 'src/app/performance/store/actions/performance.actions';

import * as cycleActions from '../store/actions/cycle.actions';

@Injectable({
  providedIn: 'root',
})
export class CyclesGuard {
  constructor(private store: Store<RootState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(cycleActions.loadData());
    const cycleId = +route.paramMap.get('cycleId');
    if (cycleId) {
      this.store.dispatch(
        loadObservationsForCycleRequest({
          cycleId,
        }),
      );
    } else {
      this.store.dispatch(
        loadObservationsForCycleSuccess({
          observations: [],
        }),
      );
    }
    return of(true);
  }
}
